import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HealthDiaryPage = lazy(() => import("./HealthDiaryPage"));

const HealthDiaryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HealthDiaryPage />
    </Suspense>
  );
};

export default HealthDiaryPageLazy;
